export default __webpack_public_path__ + "static/media/unfold.b4726181.svg";